(function(){
  // Bind once. `shopify theme dev` hot-reload re-evaluates this file on every save,
  // and a second set of listeners would add the item to the cart twice per click.
  if(window.__celwelBound) return;
  window.__celwelBound = true;

  // ---------- Cart helpers ----------
  function cartUrl(suffix){
    return ((window.routes && window.routes.cart_url) || '/cart') + suffix;
  }
  // celwel-header renders the count server-side, so refresh it after an AJAX add.
  function refreshCartCount(){
    fetch(cartUrl('.js'), { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        document.querySelectorAll('[data-cart-count]').forEach(function(el){
          el.textContent = String(cart.item_count);
        });
      })
      .catch(function(){});
  }
  function closeToast(){
    var t = document.querySelector('.cw-toast');
    if(!t) return;
    t.classList.remove('open');
    setTimeout(function(){ if(t.parentNode) t.parentNode.removeChild(t); }, 240);
  }
  function showToast(title, image){
    closeToast();
    var t = document.createElement('div');
    t.className = 'cw-toast';
    t.setAttribute('role', 'status');
    t.setAttribute('aria-live', 'polite');
    t.innerHTML =
      '<button class="cw-toast__x" type="button" data-toast-close aria-label="Close">&times;</button>' +
      (image ? '<img class="cw-toast__img" src="' + image + '" alt="" width="56" height="56">' : '') +
      '<div class="cw-toast__body">' +
        '<p class="cw-toast__eyebrow">Added to cart</p>' +
        '<p class="cw-toast__title"></p>' +
        '<div class="cw-toast__row">' +
          '<a class="btn btn-primary" href="' + cartUrl('') + '">View cart <span class="arr">&rarr;</span></a>' +
          '<button class="btn-ghost cw-toast__keep" type="button" data-toast-close>Keep shopping</button>' +
        '</div>' +
      '</div>';
    // textContent, not innerHTML — the title comes back from the cart API.
    t.querySelector('.cw-toast__title').textContent = title || 'Item added';
    document.body.appendChild(t);
    requestAnimationFrame(function(){ t.classList.add('open'); });
  }

  document.addEventListener('click', function(e){
    var t = e.target;
    if(!t) return;
    // Toast dismiss
    if(t.closest && t.closest('[data-toast-close]')){ closeToast(); return; }
    // Mobile menu toggle
    var nt = t.closest && t.closest('[data-nav-toggle]');
    if(nt){
      var m = document.querySelector('.mobile-menu');
      if(m) m.classList.toggle('open');
      return;
    }
    // FAQ accordion
    var q = t.closest && t.closest('.faq-q');
    if(q){
      var item = q.closest('.faq-item');
      var ans = item && item.querySelector('.faq-a');
      if(item && ans){
        var open = item.classList.toggle('open');
        ans.style.maxHeight = open ? ans.scrollHeight + 'px' : '0';
      }
      return;
    }
    // Quantity stepper
    var b = t.closest && t.closest('[data-qty]');
    if(b){
      var w = b.closest('.qty'); if(!w) return;
      var v = w.querySelector('.val'); if(!v) return;
      var n = parseInt(v.textContent, 10) || 1;
      n += b.getAttribute('data-qty') === 'up' ? 1 : -1;
      if(n < 1) n = 1; if(n > 9) n = 9;
      v.textContent = String(n);
      var price = w.getAttribute('data-price');
      if(price){
        var tgt = w.getAttribute('data-target');
        var out = tgt ? document.querySelector('[data-total="'+tgt+'"]') : document.querySelector('[data-total]');
        if(out) out.textContent = '$' + (parseInt(price,10) * n).toLocaleString();
      }
      // Sync to Shopify form qty input
      var form = w.closest('form'); if(form){
        var qi = form.querySelector('input[name="quantity"]');
        if(qi) qi.value = String(n);
      }
    }
  });
  window.addEventListener('resize', function(){
    document.querySelectorAll('.faq-item.open .faq-a').forEach(function(a){
      a.style.maxHeight = a.scrollHeight + 'px';
    });
  });
  // ---------- Add to cart, in place ----------
  // Dawn's product-form.js falls back to `window.location = /cart` when no
  // <cart-notification>/<cart-drawer> exists — and celwel-header renders neither.
  // So celwel sections post to /cart/add themselves and stay on the page.
  document.addEventListener('submit', function(e){
    var f = e.target.closest && e.target.closest('form[data-cw-add]');
    if(!f) return;
    e.preventDefault();
    var btn = f.querySelector('[type="submit"]');
    var err = f.querySelector('[data-cw-error]');
    if(err){ err.hidden = true; err.textContent = ''; }
    if(btn){ btn.setAttribute('aria-disabled', 'true'); }
    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      body: new FormData(f)
    })
      .then(function(r){ return r.json(); })
      .then(function(res){
        // Shopify returns a `status` key only on failure (sold out, qty limits).
        if(res.status){
          if(err){ err.textContent = res.description || res.message || 'Sorry, this could not be added to your cart.'; err.hidden = false; }
          return;
        }
        showToast(res.product_title || res.title, res.image);
        refreshCartCount();
      })
      .catch(function(){
        if(err){ err.textContent = 'Sorry, this could not be added to your cart. Please try again.'; err.hidden = false; }
      })
      .finally(function(){
        if(btn) btn.removeAttribute('aria-disabled');
      });
  });

  document.addEventListener('submit', function(e){
    var f = e.target.closest && e.target.closest('form[data-demo]');
    if(!f) return;
    e.preventDefault();
    var note = f.querySelector('[data-form-note]');
    if(note){ note.hidden = false; note.scrollIntoView({block:'nearest'}); }
    f.querySelectorAll('input,select,textarea,button').forEach(function(el){ el.disabled = true; });
  });
})();
